/* eslint-disable */
import React, { useState } from "react"
import { useForm, Controller } from 'react-hook-form';
import TextField from '../TextFieldCustom';
import Select from '../Select';
import Button from '../Button';
import { useSubmitForm } from '../../hooks/hook.submit-form';

import provinceItaliane from '../../assets/province-italiane.json';
import FormComunitaAmica from "./form.comunita-amica"

const FormCorsiLaureaAmici = ({ setShowThankYouPage, disclaimer }) => {
  const {
    handleSubmit,
    register,
    errors,
    control
  } = useForm({
    mode: 'onFocus'
  });

  const [loadingOnSubmit, setLoadingOnSubmit] = useState({
    label: 'Invia',
    disabled: false
  });

  const onSubmit = (data) => {
    setLoadingOnSubmit({
        label: 'Sto Inviando',
        disabled: true
      }
    );
    useSubmitForm(
      data,
      433,
      () => setShowThankYouPage(true),
      () => {
        setLoadingOnSubmit({
            label: 'Invia',
            disabled: false
          }
        );
        alert('Ops, errore di rete, ritenta l\'invio');
      }
    );
  };

  return (
    <form noValidate className="form-group" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group__container">
        <h3 className="form-group__title heading-md">Corsi di Laurea Amici</h3>

        {/** NAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          name="Nome"
          label="Nome"
          error={errors['Nome'] ? errors['Nome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il nome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** SURNAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          id="cognome"
          label="Cognome"
          name="Cognome"
          error={errors['Cognome'] ? errors['Cognome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il cognome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** QUALIFICATION */}
        <TextField
          type="text"
          name="Qualifica"
          label="Qualifica"
          className="form-group__textfield"
          required
          error={errors['Qualifica'] ? errors['Qualifica'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** DEGREE COURSE */}
        <TextField
          type="text"
          name="Corso di Laurea"
          label="Corso di laurea di appartenenza"
          className="form-group__textfield"
          required
          error={errors['Corso di Laurea'] ? errors['Corso di Laurea'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono"
          required
          className="form-group__textfield"
          error={errors['Telefono'] ? errors['Telefono'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** EMAIL */}
        <TextField
          className="form-group__textfield"
          type="text"
          label="Email"
          name="Email"
          required
          error={errors['Email'] ? errors['Email'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        <h4 className="form-group__subtitle heading-md">Dati del corso di laurea</h4>
        {/** DENOMINATION */}
        <TextField
          type="text"
          name="Denominazione CL"
          label="Denominazione"
          className="form-group__textfield"
          required
          error={errors['Denominazione CL'] ? errors['Denominazione CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** ADDRESS */}
        <TextField
          type="text"
          name="Indirizzo CL"
          label="Indirizzo (compreso numero civico)"
          className="form-group__textfield"
          required
          error={errors['Indirizzo CL'] ? errors['Indirizzo CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** CAP */}
        <TextField
          type="text"
          name="Cap CL"
          label="CAP"
          className="form-group__textfield"
          required
          error={errors['Cap CL'] ? errors['Cap CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono CL"
          required
          className="form-group__textfield"
          error={errors['Telefono CL'] ? errors['Telefono CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** CITY */}
        <TextField
          type="text"
          name="Citta CL"
          label="Città"
          className="form-group__textfield"
          required
          error={errors['Citta CL'] ? errors['Citta CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PROVINCE */}
        <Controller
          control={control}
          name="Provincia CL"
          rules={{ required: 'Campo obbligatorio' }}
          render={({ onChange }) => (
            <Select
              className="form-group__select"
              label="Provincia"
              name="Provincia CL"
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              error={errors['Provincia CL'] ? errors['Provincia CL'].message : ''}
              required
              inputRef={register()}
            />
          )}
        />

        {/** MUNICIPALITY */}
        <TextField
          type="text"
          id="comnune"
          name="Comune CL"
          label="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune CL'] ? errors['Comune CL'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** WEBSITE */}
        <TextField
          type="text"
          name="Sito Web CL"
          label="Sito Web"
          className="form-group__textfield"
          inputRef={register()}
        />

        <h4 className="form-group__subtitle heading-md">Dati dell'università</h4>
        {/** DENOMINATION */}
        <TextField
          type="text"
          name="Denominazione Uni"
          label="Denominazione"
          className="form-group__textfield"
          required
          error={errors['Denominazione Uni'] ? errors['Denominazione Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** ADDRESS */}
        <TextField
          type="text"
          name="Indirizzo Uni"
          label="Indirizzo (compreso numero civico)"
          className="form-group__textfield"
          required
          error={errors['Indirizzo Uni'] ? errors['Indirizzo Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** CAP */}
        <TextField
          type="text"
          name="Cap Uni"
          label="CAP"
          className="form-group__textfield"
          required
          error={errors['Cap Uni'] ? errors['Cap Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          id="demo-1"
          label="Telefono"
          name="Telefono Uni"
          required
          className="form-group__textfield"
          error={errors['Telefono Uni'] ? errors['Telefono Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** CITY */}
        <TextField
          type="text"
          name="Citta Uni"
          label="Città"
          className="form-group__textfield"
          required
          error={errors['Citta Uni'] ? errors['Citta Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PROVINCE */}
        <Controller
          control={control}
          name="Provincia Uni"
          rules={{ required: 'Campo obbligatorio' }}
          render={({ onChange }) => (
            <Select
              className="form-group__select"
              label="Provincia"
              name="Provincia Uni"
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              error={errors['Provincia Uni'] ? errors['Provincia Uni'].message : ''}
              required
              inputRef={register()}
            />
          )}
        />

        {/** MUNICIPALITY */}
        <TextField
          type="text"
          name="Comune Uni"
          label="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune Uni'] ? errors['Comune Uni'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** WEBSITE */}
        <TextField
          type="text"
          name="Sito Web Uni"
          label="Sito Web"
          className="form-group__textfield"
          inputRef={register()}
        />

        {/** RECTOR'S EMAIL */}
        <TextField
          type="text"
          name="Email Rettore"
          label="Email Rettore"
          className="form-group__textfield"
          inputRef={register({
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        {/** PRIVACY POLICY */}
        <div className="paragraph-small" dangerouslySetInnerHTML={{__html: disclaimer}} />
        <div className="form-group__privacy">
          {/** SUBMIT BUTTON */}
          <Button type="submit" kind="primary" disabled={loadingOnSubmit.disabled} label={loadingOnSubmit.label} color="brand" />
        </div>
      </div>
    </form>
  );
};

FormCorsiLaureaAmici.defaultProps = {
  disclaimer:
    '          <strong>Informativa ex art.13, GDPR</strong>\n' +
    '\n' +
    '          <p>Titolare del trattamento dei dati è il Comitato Italiano per l’UNICEF - Fondazione ONLUS , Via Palestro 68, 00185 Roma (RM).\n' +
    '            I dati personali saranno trattati con modalità prevalentemente elettroniche per le seguenti finalità:</p>\n' +
    '          <ul>\n' +
    '            <li>a) Inviare il materiale richiesto e/o dare riscontro alle richieste avanzate per l’adesione al Percorso di interesse</li>\n' +
    '            <li>b) Ottemperare a norme di legge o regolamento</li>\n' +
    '            <li>c) Fornire informazioni su iniziative/programmi di sensibilizzazione e promozione dei diritti dei bambini</li>\n' +
    '          </ul>\n' +
    '          <p>Per le finalità ai punti a) e b), il trattamento dei dati è ammesso senza il consenso dell’interessato ai sensi dell’art. 6 comma 1, lett. b) e c)\n' +
    '            GDPR; i dati saranno conservati per il tempo necessario a rispondere alle richieste e per eventuali contatti di approfondimento che permettano di\n' +
    '            valutare se aderire all’ iniziativa di interesse; in ogni caso per il periodo consentito dalla legge per esigenze di tutela legale. Per le finalità al\n' +
    '            punto c) il trattamento è ammesso ai sensi dell’art. 6 comma 1 lettera f) GDPR (“legittimo interesse”); i dati verranno conservati per il periodo\n' +
    '            consentito dalla legge per esigenze di tutela legale; la conservazione può essere di tempo inferiore se non si ha più\n' +
    '            interesse ad essere informati e lo si comunica con le modalità sotto riportate.</p>\n' +
    '          <p>Per i predetti fini saranno conservati anche successivamente, laddove leggi, regolamenti o normativa comunitaria ne determinino\n' +
    '            la conservazione per tempi differenti. Inoltre, saranno conservati in caso di imposizione da parte delle Forze dell’Ordine,\n' +
    '            della Magistratura e Organi di Controllo e per far valere o difendere diritti in sede giudiziaria. Le persone autorizzate al trattamento sono\n' +
    '            gli addetti all’amministrazione e organizzatori dell’iniziativa, alle attività istituzionali e statutarie, dei sistemi informativi e di sicurezza dei dati.</p>\n' +
    '          <p>Ai sensi degli artt. 15-22, GDPR, scrivendo all’e-mail <a href="mailto:infoprivacy@unicef.it">infoprivacy@unicef.it</a>,\n' +
    '            si può richiedere l’elenco completo e aggiornato dei responsabili del trattamento, nonché esercitare i diritti di consultazione,\n' +
    '            modificazione, di cancellazione e oblio, limitazione del trattamento dei dati, portabilità dei dati o opporsi al loro trattamento. Inoltre,\n' +
    '            l’interessato ha diritto di presentare reclamo all’autorità di controllo – per l’Italia è il Garante per la protezione dei dati personali\n' +
    '            – <a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a>, per far valere i propri diritti. Il Data Protection Officer\n' +
    '            è contattabile all’e-mail <a href="mailto:dpo@unicef.it">dpo@unicef.it</a>, per informazioni sul trattamento dei dati.</p>\n' +
    '\n' +
    '          Informativa completa al sito <a href="https://www.unicef.it/note-sulla-privacy">www.unicef.it/privacy</a>\n'
}

export default FormCorsiLaureaAmici;
